module.exports = __webpack_public_path__ + "img/perfil_dorso_plano.d65707e0.jpg";